import type {
  ComponentProps,
  CSSProperties,
  ElementType,
  MouseEventHandler,
  ReactNode,
} from "react";
import styles from "./Card.module.css";
// @ts-expect-error pure js
import { classnames } from "../../utils";

interface CardProps extends ComponentProps<"div"> {
  as?: ElementType;
  children?: ReactNode;
  checked?: boolean;
  className?: string;
  style?: CSSProperties;
  onClick?: MouseEventHandler;
  type?: string;
  noCard?: boolean;
  padding?: "xs" | "sm" | "md" | "lg" | "none";
  disabled?: boolean;
}

export default function Card({
  as: Component = "div",
  children,
  checked,
  className,
  style,
  onClick,
  type,
  noCard,
  padding,
  ...rest
}: CardProps) {
  return (
    <Component
      onClick={onClick}
      style={style}
      className={
        noCard
          ? undefined
          : classnames(
              styles.card,
              checked && styles.checked,
              className,
              styles[type as keyof typeof styles],
              styles[`padding-${padding}` as keyof typeof styles],
              onClick && styles.action,
            )
      }
      {...rest}
    >
      {children}
    </Component>
  );
}
